import { Component, forwardRef, Injector, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { AutocompleteComponent } from '@components/autocomplete/autocomplete.component';
import { EmailApi } from '@api/email.api';
import { EMPTY_AUTOCOMPLETE_VALUE } from '@configs/autocomplete';
import { AutocompleteValue, EmptyAutocompleteValue } from '@models/autocomplete';
import { EmailTemplate, SearchEmailTemplate } from '@models/email';
import { TableData } from '@models/table';

@Component({
  selector: 'app-email-template-autocomplete',
  templateUrl: './email-template-autocomplete.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef((): any => EmailTemplateAutocompleteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: EmailTemplateAutocompleteComponent,
      multi: true
    }
  ]
})
export class EmailTemplateAutocompleteComponent extends AutocompleteComponent {
  @Input() public override label: string = 'Email Template';
  @Input() public override placeholder: string = 'Search for a email template...';
  @Input('aria-label') public override ariaLabel: string = 'Email template autocomplete';
  @Input() public override hint: string = 'Select an email template. (will overwrite any changes you may have made below)';

  protected override readonly switchMap: boolean = true;

  constructor(injector: Injector, private api: EmailApi) {
    super(injector);
  }

  public displayFn = (emailTemplate: EmailTemplate): string => {
    return emailTemplate ? emailTemplate.name : '';
  };

  protected override searchByQuery(query: string): Observable<Array<AutocompleteValue>> {
    return this.api.getSearchForTemplates({page: 1, limit: 10, keyword: query}).pipe(
      tap((data: TableData<SearchEmailTemplate>): Array<SearchEmailTemplate> => this.allItems = data.items),
      map((): Array<AutocompleteValue> => this.composeAutocompleteValues()),
      catchError((): Observable<Array<EmptyAutocompleteValue>> => of(EMPTY_AUTOCOMPLETE_VALUE))
    );
  }
}
